export const products = [
  { 
    id: 1, 
    title: 'Macbook Pro Sleeve 13"', 
    price: '$50', 
    image: '/whitesleeve.webp',
    overview: "Slim, water-resistant sleeve designed specifically for the MacBook Pro 13-inch, offering reliable protection without bulk.",
    highlights: [
      "Premium 600D polyester exterior with water-resistant coating",
      "Soft 4mm neoprene padding with plush interior",
      "Smooth YKK zipper with custom pull",
      "Reinforced edges prevent wear and tear"
    ],
    techSpecs: {
      dimensions: "13.3\" x 9.25\" x 0.75\"",
      material: "600D polyester exterior, neoprene core, felt interior",
      compatibility: "All 13-inch MacBook Pro models",
      weight: "0.28 lbs"
    }
  },
  { 
    id: 2, 
    title: 'iPad Pro Sleeve 11"', 
    price: '$30', 
    image: '/UltraSleeve_14_slategreen.webp',
    overview: "Minimalist sleeve that perfectly fits the iPad Pro 11-inch, providing essential protection for daily use.",
    highlights: [
      "Durable neoprene exterior with water-resistant finish",
      "Soft microfiber interior prevents scratches",
      "Secure magnetic snap closure",
      "Slim profile fits easily in bags"
    ],
    techSpecs: {
      dimensions: "11.5\" x 8.25\" x 0.5\"",
      material: "Neoprene exterior, microfiber interior",
      compatibility: "iPad Pro 11\" ",
      weight: "0.2 lbs"
    }
  },
  { 
    id: 3, 
    title: 'Macbook Air Sleeve 13"', 
    price: '$50', 
    image: '/UltraSleeve_16_rose.webp',
    overview: "Sleek protective sleeve perfectly tailored for the MacBook Air 13-inch, balancing style and functionality.",
    highlights: [
      "Durable 600D polyester with water-resistant coating",
      "Plush felt interior with 3mm foam padding",
      "Full-length YKK zipper for easy access",
      "Slim design maintains MacBook Air's portability"
    ],
    techSpecs: {
      dimensions: "13.3\" x 9.25\" x 0.6\"",
      material: "600D polyester exterior, foam core, felt interior",
      compatibility: "All MacBook Air 13\" models",
      weight: "0.25 lbs"
    }
  },
  { 
    id: 4, 
    title: 'iPad Mini Sleeve', 
    price: '$25', 
    image: '/ipadsleeve.webp',
    overview: "Compact protective sleeve designed specifically for the iPad Mini, perfect for everyday carry.",
    highlights: [
      "Lightweight neoprene construction",
      "Soft-touch interior lining",
      "Secure zip closure",
      "Ultra-portable design"
    ],
    techSpecs: {
      dimensions: "8.75\" x 6.25\" x 0.4\"",
      material: "Neoprene exterior and interior",
      compatibility: "All iPad Mini generations",
      weight: "0.15 lbs"
    }
  },
]; 